import { Injectable } from '@angular/core';
import { FeatureService } from '../services/feature.service';

@Injectable()
export class HasFeatureResolver {

  constructor(private featureService: FeatureService) { }

  init() {
    return this.featureService.isFeatureEnabled('InstallationV2').map((mainFeatureEnabled) => {
      return {
        mainFeatureEnabled
      };
    });
  }
}
